import appLogger from '@/utils/logger';
import { apiInstance } from '@/utils'; // Corrected import based on offers.ts
import { handleShowError } from '@/utils'; // This should be correct now

export interface ITransferQuestion {
  id?: number; // Optional, present in GET response
  question_text: string;
  question_order: number;
  is_required: boolean;
  input_type: string;
  is_active: boolean;
}

export interface ITransferQuestionsPayload {
  questions: ITransferQuestion[];
  platform: 'teams' | 'slack';
  enabled: boolean; // Per-bot Human Handoff on/off
}

export interface ISetTransferQuestionsBody {
  chat_token: string;
  platform?: 'teams' | 'slack'; // Add optional platform field
  questions: Omit<ITransferQuestion, 'id'>[];
  enabled?: boolean; // Per-bot Human Handoff on/off
}

function sortQuestions(list: ITransferQuestion[]): ITransferQuestion[] {
  return [...list].sort((a, b) => a.question_order - b.question_order);
}

// Fetches transfer questions and saved handoff platform for a given chat token
export const getTransferQuestions = async (chat_token: string): Promise<ITransferQuestionsPayload> => {
  if (!chat_token) {
    appLogger.warn('getTransferQuestions called without chat_token');
    return { questions: [], platform: 'teams', enabled: true };
  }
  try {
    const url = '/private/training/transfer-questions';
    appLogger.info('[DEBUG] Making GET request to:', { data: apiInstance.getUri({ url, params: { chat_token } }) }); // Log the full URL Axios will use
    const response = await apiInstance.get(url, {
      params: { chat_token },
    });
    const raw = response.data;
    if (Array.isArray(raw)) {
      return {
        questions: sortQuestions(raw as ITransferQuestion[]),
        platform: 'teams',
        enabled: true,
      };
    }
    const body = raw as { questions?: ITransferQuestion[]; platform?: string; enabled?: boolean };
    const platform = body.platform === 'slack' ? 'slack' : 'teams';
    return {
      questions: sortQuestions(body.questions ?? []),
      platform,
      enabled: body.enabled !== false,
    };
  } catch (error) {
    handleShowError(error);
    throw error; // Re-throw to be caught by react-query
  }
};

// Sets the list of transfer questions, replacing existing ones
export const setTransferQuestions = async (
  body: ISetTransferQuestionsBody,
): Promise<{ success: boolean }> => {
  try {
    const url = '/private/training/transfer-questions';
    appLogger.info('[DEBUG] Making POST request to:', { data: apiInstance.getUri({ url }) }); // Log the full URL Axios will use
    const response = await apiInstance.post(url, body);
    return response.data;
  } catch (error) {
    handleShowError(error);
    throw error; // Re-throw to be caught by react-query
  }
};
